export const PPT_GET_PPT_SCRIM = "PPT_GET_PPT_SCRIM";
export const PPT_GET_PPT_SCRIM_REQUESTED = "PPT_GET_PPT_SCRIM_REQUESTED";
export const PPT_GET_PPT_SCRIM_SUCCESS = "PPT_GET_PPT_SCRIM_SUCCESS";
export const PPT_GET_PPT_SCRIM_FAILED = "PPT_GET_PPT_SCRIM_FAILED";
export const PPT_GET_PPT_SCRIM_CLEAR = "PPT_GET_PPT_SCRIM_CLEAR";

export const PPT_GET_PPT_CUP = "PPT_GET_PPT_CUP";
export const PPT_GET_PPT_CUP_REQUESTED = "PPT_GET_PPT_CUP_REQUESTED";
export const PPT_GET_PPT_CUP_SUCCESS = "PPT_GET_PPT_CUP_SUCCESS";
export const PPT_GET_PPT_CUP_FAILED = "PPT_GET_PPT_CUP_FAILED";
export const PPT_GET_PPT_CUP_CLEAR = "PPT_GET_PPT_CUP_CLEAR";

export const PPT_GET_PPT_MASTER = "PPT_GET_PPT_MASTER";
export const PPT_GET_PPT_MASTER_REQUESTED = "PPT_GET_PPT_MASTER_REQUESTED";
export const PPT_GET_PPT_MASTER_SUCCESS = "PPT_GET_PPT_MASTER_SUCCESS";
export const PPT_GET_PPT_MASTER_FAILED = "PPT_GET_PPT_MASTER_FAILED";
export const PPT_GET_PPT_MASTER_CLEAR = "PPT_GET_PPT_MASTER_CLEAR";

export const PPT_FILTER_PPT = "PPT_FILTER_PPT";
export const PPT_FILTER_PPT_REQUESTED = "PPT_FILTER_PPT_REQUESTED";
export const PPT_FILTER_PPT_SUCCESS = "PPT_FILTER_PPT_SUCCESS";
export const PPT_FILTER_PPT_FAILED = "PPT_FILTER_PPT_FAILED";
export const PPT_FILTER_PPT_CLEAR = "PPT_FILTER_PPT_CLEAR";

export const PPT_GET_PPT_PAGINATED = "PPT_GET_PPT_PAGINATED";
export const PPT_GET_PPT_REQUESTED_PAGINATED =
  "PPT_GET_PPT_REQUESTED_PAGINATED";
export const PPT_GET_PPT_SUCCESS_PAGINATED =
  "PPT_GET_PPT_SUCCESS_PAGINATED";
export const PPT_GET_PPT_FAILED_PAGINATED =
  "PPT_GET_PPT_FAILED_PAGINATED";
export const PPT_GET_PPT_CLEAR_PAGINATED =
  "PPT_GET_PPT_CLEAR_PAGINATED";
